import angular from "../_snowpack/pkg/angular.js";
import {Configs, Language, Translations} from "../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {AppInsightExceptionTracking, SitemapHelper} from "../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
import {OnAuthenticatedSession} from "./on-authenticated-session.js";
Configs.current = {...Configs.current, ...{applicationId: "COMPANY"}};
export const module = angular.module("salaxyApp", ["ngRoute", "salaxy.ng1.components.all"]).constant("SITEMAP", (() => {
  return SitemapHelper.getCompanySiteMap();
})()).config(["RouteHelperProvider", (routeHelperProvider) => {
  routeHelperProvider.defaultSection("calc", ["pro", "versions"], "calc");
  routeHelperProvider.commit();
}]).config(AppInsightExceptionTracking).run(["UiHelpers", "SessionService", (uiHelpers, sessionService) => {
  sessionService.clientRoles.push("payslip");
  if (Configs.current.isTestData) {
    sessionService.clientRoles.push("repairs");
  }
}]).run(OnAuthenticatedSession).run([() => {
  Translations.loadLanguage(Language.Fi);
}]);
export const modulePro = angular.module("salaxyAppPro", ["ngRoute", "salaxy.ng1.components.all"]).constant("SITEMAP", (() => {
  return SitemapHelper.getCompanySiteMap();
})()).config(["RouteHelperProvider", (routeHelperProvider) => {
  routeHelperProvider.defaultSection("calc", ["pro", "versions"], "calc");
  routeHelperProvider.commit();
}]).config(AppInsightExceptionTracking).run(["UiHelpers", "SessionService", (uiHelpers, sessionService) => {
  if (Configs.current.isTestData) {
    sessionService.clientRoles.push("repairs");
  }
  if (!sessionService.clientRoles.find((x) => x === "pro")) {
    sessionService.clientRoles.push("pro");
  }
}]).run(OnAuthenticatedSession).run([() => {
  Translations.loadLanguage(Language.Fi);
}]);
